import React from 'react'
import RoomInboxButton from './RoomInboxButton'
import RoomRulesButton from './RoomRulesButton'

interface Props {
  unreadCount: number
  onChatClick: () => void
  onRulesClick?: () => void
  showRules?: boolean
  className?: string
}

/** Centered colorful chat + rules shortcuts for room ranking headers. */
const RoomChatRulesActions: React.FC<Props> = ({
  unreadCount,
  onChatClick,
  onRulesClick,
  showRules = true,
  className = '',
}) => (
  <div className={`flex items-center justify-center gap-2 sm:gap-3 ${className}`}>
    <RoomInboxButton unreadCount={unreadCount} onClick={onChatClick} />
    {showRules && onRulesClick ? <RoomRulesButton onClick={onRulesClick} /> : null}
  </div>
)

export default RoomChatRulesActions
